// extracted by mini-css-extract-plugin
export default {"spacer":"Layout_spacer__OJhRf"};